import React, { Component } from "react";
import DATEPICKER_OR from "../../../../common/custom-form/custom-date-picker.component";
import { InputField } from "../../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../../common/custom-form/select-filter.component";
import { Button } from "react-bootstrap";
export class DisputeManagement extends Component {
    constructor(props){
        super(props);
        this.state={
            inputValue: "",
            filterSelected: "", 
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
        }
    }
    render() {
        return(
            <>
            <h1>Finance Management - Dispute</h1>
            <div className="manage-order-container">
                <div className="manage-order-detail">
                    <InputField label="DISPUTED ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <SelectField label="INVOICE NUMBER"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>
                    <InputField label="ACCOUNT NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="SUB ACCOUNT NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="VENDOR" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="CURENCY" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <SelectField label="DISPUTE RATE"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>
                    <SelectField label="DISPUTE STATUS"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>
                    <InputField label="CIRCUIT ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="CARRIER TRACKING ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <SelectField label="CLAIM TYPE"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>
                    <SelectField label="FREQUENCY"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>
                    <InputField label="DESCRIPTION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="COMMENT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                </div>
            </div>
            <h1>Other Details</h1>
            <div className="manage-order-container">  
                 <div className="manage-order-detail">
                    <DATEPICKER_OR label="CREATION DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                    <DATEPICKER_OR label="CREDIT RECEIVE DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                    <DATEPICKER_OR label="CLOSE DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                    <InputField label="DISPUTED AMOUNT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="EXPECTED AMOUNT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="BILLED AMOUNT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="CREDITS RECEIVED" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="PROJECT YEARLY SAVINGS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <SelectField label="ASSIGNED USER"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>
                 </div>   
            </div>   
            {
                !this.props.modalView &&
                <div className="save-btn-container">
                    <Button className="save-button"> Save Changes </Button>                                   
                </div>  
            }                                     
                                         
        </>
        )
    }
}